<template>
  <div :class="odd ? 'card card card-odd' : 'card card card-even'">
    <div class="card-image relative" style>
      <figure class="image hover-on-img" @click="clicknews()">
        <img
          v-bind:src="getImgUrl(post.image)"
          :alt="post.image"
          style="height: 350px;object-fit: contain;"
        />
      </figure>
    </div>
    <div class="card-content">
      <div class="content">
        <b-taglist attached>
          <b-tag :type="color">
            <b-icon
              class="has-text-white-ter"
              :icon="icon"
              size="is-small"
            ></b-icon>
          </b-tag>
          <b-tag class="has-text-white-ter" :type="color">
            {{ $t(post.type) }}
          </b-tag>
        </b-taglist>
        <h5 class="is-size-5 hover-on-img" @click="clicknews()">
          {{ post.content[currentLocale].title }}
        </h5>
        <p>{{ post.create }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n.js";
export default {
  name: "BlogType",
  props: { post: Object, odd: Boolean },
  data() {
    return {
      locale: i18n.locale,
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/cepSuites/" + pic);
    },
    clicknews() {
      this.$router.push({
        path: `/${this.post.type}/${this.post.path}`,
        params: { post: this.post },
      });
      // this.$router.push(`${this.post.type}/${this.post.type}`, props:{post:this.post})
    },
  },
  computed: {
    currentLocale() {
      return i18n.locale;
    },
    icon() {
      let value = "flag";
      switch (this.post.type) {
        case "evento":
          value = "calendar-day";
          break;
        case "lanzamiento":
          value = "rocket";
          break;
        case "novedad":
          value = "tag";
          break;
        case "noticia":
          value = "newspaper";
          break;
      }
      return value;
    },
    color() {
      let value = "is-info";
      switch (this.post.type) {
        case "evento":
          value = "has-background-success";
          break;
        case "lanzamiento":
          value = "has-background-link";
          break;
        case "novedad":
          value = "has-background-warning";
          break;
        case "noticia":
          value = "has-background-grey";
          break;
      }
      return value;
    },
  },
};
</script>
<i18n>
{
  "es": {
    "evento":"evento",
    "lanzamiento":"lanzamiento",
    "novedad":"novedad",
    "noticia":"noticia"
  },
  "en": {
    "evento":"event",
    "lanzamiento":"launch",
    "novedad":"novelty",
    "noticia":"news"
  },
  "pt": {
    "eveeventont":"evento",
    "lanzamiento":"lançar",
    "novedad":"novidade",
    "noticia":"Notícias"
  }
}    
</i18n>
